import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

// Components
import Header from './components/Header'
import Footer from './components/Footer'
import FloatingDock from './components/FloatingDock'
import ScrollToTop from './components/ScrollToTop'

// Pages
import Home from './pages/Home'
import About from './pages/About'
import ServiceDetail from './pages/ServiceDetail'
import GalleryPage from './pages/GalleryPage'
import ContactPage from './pages/ContactPage'
import Error403 from './pages/Error403'
import Error404 from './pages/Error404'

function App() {
  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen bg-white text-zinc-800 antialiased font-sans">
        {/* Scroll restoration */}
        <ScrollToTop />

        {/* Header Navigation */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/ydelser/:slug" element={<ServiceDetail />} />
            <Route path="/galleri" element={<GalleryPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/403" element={<Error403 />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />

        {/* Floating Dock & Mobile sticky bar */}
        <FloatingDock />
      </div>
    </HelmetProvider>
  )
}

export default App
